<template>
  <div v-if="showComponent" :class="{ row : isOnModeLabelOnLeft}">
    <!-- <hr class="mt-0"> -->
    <label class="mb-4 d-flex justify-content-between">
      <h4 class="d-inline my-0">{{label}}</h4>
      <div>
        <font-awesome-icon
          id="font-awesome-icon-edit"
          icon="edit"
          size="sm"
          class="clickable float-right mt-1"
          :class="{ 'ml-2': help }"
          v-if="showEditButton"
          @click="$emit('edit-button-clicked')"
        />
        <font-awesome-icon
          icon="question-circle"
          size="sm"
          class="clickable float-right mt-1"
          v-if="help"
          v-b-tooltip.hover="help"
        />
      </div>
    </label>
    <LmComponentLoading v-if="loading" />
    <div v-if="!loading">
      <div class="row" v-for="(val, key, groupIndex) of formObjectToSendToServer" :key="groupIndex">
        <div class="col-12 d-inline-flex justify-content-between align-items-center">
          <h6>{{`${labelGroup || 'Grupo'} ${isLabelGroupNumber ? groupIndex+1 : ''}`}}</h6>
          <font-awesome-icon
            v-if="Object.keys(formObjectToSendToServer).length > 1"
            :key="groupIndex"
            id="font-awesome-icon-edit"
            icon="times"
            size="sm"
            class="clickable float-right mt-1"
            @click="removeGroup(key)"
            v-b-tooltip.hover="'Eliminar Grupo'"
          />
        </div>
        <hr>
        <template v-for="(item, index) in items.formElements">
          <component
            :disabled="disabled"
            v-if="`group_${item.group}` === key"
            :ref="`componentRef${index}_${key}`"
            :key="`label_${index}_${key}`"
            :id="`componentId${index}_${key}`"
            :class="item.class"
            :is="item.componentName"
            v-bind="item.componentProps"
            v-model="formObjectToSendToServer[`group_${item.group}`][item.formObjectToSendToServerProperty]"
            :defaultValue="item.componentName === 'LmSuperPowerSelectV2' ? formObjectToSendToServer[item.formObjectToSendToServerProperty] : null"
            @input="sendFormObjectToSendToServer"
            @onUpload="onUpload"
            :v="$v.formObjectToSendToServerForValidations[`group_${item.group}`][item.formObjectToSendToServerProperty]"
          />
        </template>
      </div>
    </div>
    <LmButton
      v-if="!disabled"
      :disabled="!items.formElements.length"
      lmButtonRootWrapperClass="d-inline-block"
      buttonClass="btn-primary mt-2 mb-2"
      :value="$t(buttonText)"
      type='button'
      @click.native="agregar"
    />
    <hr class="mb-4">
  </div>
</template>

<script>
import {
  required,
  email,
  minLength,
  maxLength,
  numeric,
  sameAs
} from 'vuelidate/lib/validators'
import _ from 'lodash'
import lmInputMixin from '@/mixins/lmInputMixin.js'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmPassword from '@/components/form/elements/LmPassword'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmNumberInputV2 from '@/components/form/elements/LmNumberInputV2'
import LmDate from '@/components/form/elements/LmDate'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmFormSubtitles from '@/components/form/elements/LmFormSubtitles'
import LmFormEmptySpace from '@/components/form/elements/LmFormEmptySpace'
import LmFormSeparator from '@/components/form/elements/LmFormSeparator'
import LmEditor from '@/components/form/elements/lmEditor'
import LmLeaFletMap from '@/components/LmLeaFletMap.vue'
import LmHtmlContent from '@/components/form/elements/LmHtmlContent'
import LmColorPicker from '@/components/form/elements/LmColorPicker'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmRadio from '@/components/form/elements/LmRadio'
import LmUploadFiles from '@/components/form/elements/LmUploadFiles'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmTagsInput from '@/components/form/elements/LmTagsInput'
import LmCodeInput from '@/components/form/elements/LmCodeInput'

export default {
  mixins: [lmInputMixin],
  components: {
    LmButton,
    LmTextInput,
    LmPassword,
    LmEmailInput,
    LmNumberInput,
    LmNumberInputV2,
    LmTextArea,
    LmSelect,
    LmFormSubtitles,
    LmFormEmptySpace,
    LmFormSeparator,
    LmDate,
    LmDateTime,
    LmEditor,
    LmLeaFletMap,
    LmHtmlContent,
    LmColorPicker,
    LmCheckbox,
    LmRadio,
    LmUploadFiles,
    LmTreeSelect,
    LmTagsInput,
    LmCodeInput
  },
  data () {
    return {
      items: {
        formElements: []
      },
      formObjectToSendToServerForValidations: {},
      initialItemsLength: 0,
      renderComponent: true,
      loading: true,
      dataSaved: {},
      firstLoad: true,
      groupCount: 1
    }
  },
  validations () {
    const validations = {
      formObjectToSendToServerForValidations: {}
    }
    for (const item of this.items.formElements) {
      if ('validations' in item) {
        for (const property in item.validations) {
          // Me aseguro de que no se pisen las validaciones y poder efectuar mas de una
          switch (property) {
            case 'required':
              _.set(
                validations.formObjectToSendToServerForValidations,
                `[group_${item.group}][${item.formObjectToSendToServerProperty}][${property}]`,
                required
              )
              break
            case 'email':
              _.set(
                validations.formObjectToSendToServerForValidations,
                `[group_${item.group}][${item.formObjectToSendToServerProperty}][${property}]`,
                email
              )
              break
            case 'minLength':
              _.set(
                validations.formObjectToSendToServerForValidations,
                `[group_${item.group}][${item.formObjectToSendToServerProperty}][${property}]`,
                minLength(Number(item.validations[property]))
              )
              break
            case 'maxLength':
              _.set(
                validations.formObjectToSendToServerForValidations,
                `[group_${item.group}][${item.formObjectToSendToServerProperty}][${property}]`,
                maxLength(Number(item.validations[property]))
              )
              break
            case 'numeric':
              _.set(
                validations.formObjectToSendToServerForValidations,
                `[group_${item.group}][${item.formObjectToSendToServerProperty}][${property}]`,
                numeric
              )
              break
            case 'sameAs':
              _.set(
                validations.formObjectToSendToServerForValidations,
                `[group_${item.group}][${item.formObjectToSendToServerProperty}][${property}]`,
                sameAs(item.validations[property])
              )
              break
            default:
              break
          }
        }
      } else {
        _.set(
          validations.formObjectToSendToServerForValidations,
          `[group_${item.group}][${item.formObjectToSendToServerProperty}]`,
          ''
        )
      }
    }
    return validations
  },
  props: {
    isVisible: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    defaultValue: {
      type: String,
      default: ''
    },
    props: {
      type: Object,
      default: () => ({})
    },
    initialItems: {
      type: Object,
      default: () => ({})
    },
    buttonText: {
      type: String,
      default: ''
    },
    labelGroup: {
      type: String,
      default: 'Grupo'
    },
    isLabelGroupNumber: {
      type: Boolean,
      default: true
    },
    isOnPreviewMode: {
      type: Object,
      default: () => ({})
    },
    v: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    formObjectToSendToServer: {
      get () {
        if (!this.items.formElements.length) {
          return {}
        }
        let obj = {}
        // Si estoy en modo edicion y es el primer load
        if (this.$route.params?.id && this.firstLoad) {
          // eslint-disable-next-line
          this.dataSaved = this.value
          // eslint-disable-next-line
          this.firstLoad = false
        }
        for (const item of this.items.formElements) {
          // Cargo la info ya escrita si existe
          let data = ''
          // El siguiente if actua cuando tengo datos previamente cargados y agrego un nuevo componente
          // Previene que se resetee su valor
          // https://github.com/lumile/lumbresign-microservices/issues/14
          if (this.value && `group_${item.group}` in this.value) {
            data = this.value[`group_${item.group}`][`${item.formObjectToSendToServerProperty}`]
          }
          if (this.dataSaved.hasOwnProperty(`group_${item.group}`)) {
            data = this.dataSaved[`group_${item.group}`][`${item.formObjectToSendToServerProperty}`]
          }
          _.set(obj, `[group_${item.group}][${item.formObjectToSendToServerProperty}]`, data)
        }
        // A vuelidate no le gusta que le pasemos una propiedad computada por eso copiamos a una del data
        // https://github.com/vuelidate/vuelidate/issues/241
        // eslint-disable-next-line
        this.formObjectToSendToServerForValidations = obj
        return obj
      },
      set (val) {}
    }
  },
  watch: {
    initialItems: {
      immediate: true,
      deep: true,
      handler (val, oldVal) {
        if (this?.initialItems?.formElements) {
          const itemsClone = _.cloneDeep(this.initialItems)
          itemsClone.formElements.forEach(el => {
            el['group'] = 0
          })
          this.items = itemsClone
          this.initialItemsLength = this?.initialItems?.formElements.length
          const obj = {}
          for (const item of this.items.formElements) {
            _.set(obj, `[group_${item.group}][${item.formObjectToSendToServerProperty}]`, '')
          }
          this.formObjectToSendToServer = obj
        }
      }
    }
  },
  created () {
    // Evita problema de asincronismo de datos
    setTimeout(() => {
      this.loading = false
    }, 500)
    // Creo un watcher que solo se ejecuta una vez y en modo edicion
    this.unWatchValue = this.$watch('value', (newVal) => {
      if (newVal && typeof newVal === 'object' && this.$route?.params?.id) {
        this.groupCount = Object.keys(newVal).length
        /*
          Se crea un componente del form por cada elemento de initialItems
          y setearle el valor guardado en la bd
        */
        const arr = []
        for (const group in newVal) {
          for (const key in newVal[group]) {
            const itemsClone = _.cloneDeep(this.items)
            const element = itemsClone.formElements.find(el => el.formObjectToSendToServerProperty === key)
            element['group'] = Number(group.split('_')[1])
            arr.push(element)
          }
        }
        this.items.formElements = arr
        this.unWatchValue()
      }
    })
  },
  methods: {
    // Elimino el grupo de items y emito los cambios
    removeGroup (groupIndex) {
      const index = Number(groupIndex.split('_')[1])
      const itemsClone = _.cloneDeep(this.items.formElements)
      this.items.formElements = itemsClone.filter(i => i.group !== index)
      delete this.dataSaved[`group_${index}`]
      this.groupCount = 0
      this.$emit('input', this.formObjectToSendToServer)
    },
    agregar () {
      let nextGroupIndex = this.groupCount
      const newElements = _.cloneDeep(this.initialItems)

      // Me aseguro de que nunca se pisen los grupos y que siempre sea un numero superior
      while (
        this.items.formElements.findIndex(el => el.group === nextGroupIndex) > -1 ||
        this.items.formElements.some(el => el.group > nextGroupIndex)
      ) {
        nextGroupIndex++
        this.groupCount++
      }

      newElements.formElements.forEach(el => {
        _.set(this.formDataToSendToServer, `[group_${nextGroupIndex}][${el.formObjectToSendToServerProperty}]`, '')
        el['group'] = nextGroupIndex
        this.items.formElements.push(el)
      })
    },
    onUpload (event) {
      // El componente LmUploadFiles no emite @change.native
      this.$emit('input', this.formObjectToSendToServer)
    },
    sendFormObjectToSendToServer () {
      // Guardo la info cargada
      this.dataSaved = _.cloneDeep(this.formObjectToSendToServer)
      // Envia al objeto formObjectToSendToServer de LmFormBuilder, que luego se utilizará para guardarlo en la base.
      this.$emit('input', this.formObjectToSendToServer)
    }
  }
}
</script>
